<template>
  <v-container fluid fill-height>
    <v-layout row wrap align-center justify-center class="text-xs-center">
      <v-flex xs12 sm8 md4>
        <div class="my-2">
          <v-icon :color="color" :style="{ fontSize:'46px' }">{{ $vuetify.icons[icon] }}</v-icon>
        </div>
        <div :class="['display-2','mb-3',`${color}--text`]">{{ $t(headline) }}</div>
        <div class="subheading my-4 font-weight-bold">{{ $t(msg) }}</div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "SomethingWentWrong",
  props: {
    icon: {
      type: String,
      default: "rms_clear"
    },
    headline: {
      type: String,
      default: "oh_no_text"
    },
    msg: {
      type: String,
      default: "not_found_result"
    },
    color: {
      type: String,
      default: "orange"
    },
  }
};
</script>

<style>
</style>
